//Style
import Styles from "./ContextMenu.module.scss"
import classnames from "classnames";

//constants
import { APP_KEY_IDS, colorOptions } from "../../constants/constants";

//Modules
import { RWebShare } from "react-web-share";
import {
  WhatsappShareButton, FacebookShareButton, TelegramShareButton, TwitterShareButton,
  EmailShareButton, LinkedinShareButton, PinterestShareButton, RedditShareButton
} from 'react-share';
import ColorStrip from "../color-strip/ColorStrip";

//Redux
import { useDispatch } from "react-redux";
import { closeWindow, openWindow } from "../../actions";


interface ContextMenuProps {
  x: number;
  y: number;
  showMenu: boolean;
}
const ContextMenu = ({ x, y, showMenu }: ContextMenuProps) => {

  const dispatch = useDispatch()

    const loadSite=()=> {
        window.open("http://priyanshdatyal-me.web.app");
    };

    const reload=()=> {
        document.documentElement.style.setProperty(('--brightness'), '0');
        document.documentElement.style.setProperty(('--saturation'), '0');
        setTimeout(() => {
            window.location.reload();
        }, 3000);
    };

    const openMail=() => {
        window.open('https://mail.google.com/mail/#inbox')
    };

    const sleepEffect = ()=>{
      document.documentElement.style.setProperty(('--brightness'), '0');
  }

  const shutDown = () => {
      sleepEffect()
      setTimeout(()=>{
          window.location.href = 'https://www.google.com';
      },2000)
  };

    const visitGithub=()=>{
        window.open("https://github.com/priyanshdatyal");
    }



    const contextOptions = [
      {
        id: "startNew",
        label: "Start New Device",
        showDivider: true,
        onclick:loadSite
      },
      {
        id: "share",
        label: "Share",
        showDivider: true,
        subOptions: [
          {
            id: "fb",
            optionCOmponent: <FacebookShareButton
              title="Priyansh Datyal Portfolio"
              url="http://priyanshdatyal-me.web.app"
              hashtag='priyandhdatyalportfolio'
              quote="I checked this guy's portfolio and man it looks amazing"
            >
              <a> Facebook</a>
            </FacebookShareButton>,
          },
          {
            id: "tg",
            optionCOmponent: <TelegramShareButton
              title="Priyansh Datyal Portfolio ------"
              url="http://priyanshdatyal-me.web.app">
              <a>Teleagram</a>
            </TelegramShareButton>,
          },
          {
            id: "li",
            optionCOmponent: <LinkedinShareButton
              title="Priyansh Datyal Portfolio"
              url="http://priyanshdatyal-me.web.app"
              summary="I checked this guy's portfolio and man it looks amazing">
              <a>LinkedIn</a>
            </LinkedinShareButton>,
          },
          {
            id: "tw",
            optionCOmponent: <TwitterShareButton
              title="Checkout this guy's Portfolio at -"
              hashtags={["compuerscience", "portfolio", "programmer", "frontend"]}
              related={["compuerscience", "portfolio", "programmer", "frontend"]}
              via="priyanshdatyal"
              url="http://priyanshdatyal-me.web.app">
              <a>Twitter</a>
            </TwitterShareButton>,
          },
          {
            id: "em",
            optionCOmponent: <EmailShareButton
              title="Priyansh Datyal Portfolio"
              url="http://priyanshdatyal-me.web.app">
              <a>Email</a>
            </EmailShareButton>,
          },
          {
            id: "rd",
            optionCOmponent: <RedditShareButton
              title="Priyansh Datyal Portfolio"
              url="http://priyanshdatyal-me.web.app">
              <a>Reddit</a>
            </RedditShareButton>,
          },
          {
            id: "ws",
            optionCOmponent: <RWebShare
              data={{
                text: "Priyansh Datyal Web",
                url: "http://priyanshdatyal-me.web.app",
                title: "Priyansh Datyal",
              }}>
              <a>From Device</a>
            </RWebShare>,
          }
        ],
      },
      {
        id: "hireMe",
        label: "Hire Me",
        onClick: () => { dispatch(openWindow(APP_KEY_IDS.HIRE)) }
      },
      {
        id: "visitGithub",
        label: "Visit Github",
        onClick: visitGithub
      },
      {
        id: "openMail",
        label: "Open Mail",
        onClick: openMail
      },
      {
        id: "settings",
        label: "Settings",
        showDivider: true,
        onClick: () => { dispatch(openWindow(APP_KEY_IDS.SETTINGS))}
      },
      {
        id: "shutDown",
        label: "Shut Down",
        onClick: shutDown
      },
      {
        id: "restart",
        label: "Restart",
        onClick: reload
      },
      {
        id: "feedback",
        label: "Feedback",
        onClick: () => { dispatch(openWindow(APP_KEY_IDS.FEEDBACK)) }
      },
      {
        id: "aboutSystem",
        label: "About System",
        onClick: () => { dispatch(openWindow(APP_KEY_IDS.ABOUT_SYSTEM)) }
      },
    ]
  
  return (
    <div style={{
      top: `${y}px`,
      left: `${x}px`,
      position: "absolute",
      display: showMenu ? "block" : "none"
    }}
      className={classnames(Styles.main_container, "glassBackground")}>

      <div className={Styles.options_container}>
        {contextOptions.slice(0, 6).map((option) => {
          return (
            <div key={option.id || option.label} className={classnames(Styles.option, option.showDivider && Styles.divider)} onClick={option.onClick}>
              {option.label}
              {
                option.subOptions &&
                <div className={classnames(Styles.suboptions_container, "glassBackground")}>
                  {option.subOptions.map((subOption, index) => {
                    return (
                      <div key={subOption.id || index} className={classnames(Styles.sub_option, index + 1 != option.subOptions.length && Styles.divider)}>{subOption.optionCOmponent}</div>
                    )
                  })}
                </div>
              }
              {option.subOptions && <div className={Styles.open_sub_menu}>▶</div>}
            </div>
          )
        })}

        <div className={Styles.color_options_container}>
          <div className={Styles.color_title}>Chose Theme</div>
          <ColorStrip />
        </div>

        {contextOptions.slice(6, contextOptions.length).map((option) => {
          return (
            <div key={option.id || option.label} className={classnames(Styles.option, option.showDivider && Styles.divider)} onClick={option.onClick}>{option.label}</div>
          )
        })}
      </div>
    </div>
  )
}

export default ContextMenu
